import { useInfiniteHits } from 'react-instantsearch';
import classNames from 'classnames';

import { type BookmakersConfig } from '@cx-modules/types';

import { type BetInsightsConfig } from '~/configuration/BetInsightsConfiguration';
import { type BettingInsightsContent, type BettingInsightsResult, type EsIndex } from '~/configuration/types';

import styles from './styles/BettingInsights.module.css';
import { ResultTable } from './ResultTable';

export function BettingInsightsResults<
  TIndex extends EsIndex,
  TContent extends BettingInsightsContent<TIndex>,
  TResult extends BettingInsightsResult<TIndex>,
>({
  bookmakers,
  config,
  resourcesUrl,
}: {
  bookmakers: BookmakersConfig;
  config: BetInsightsConfig<TIndex, TContent>;
  resourcesUrl: string;
}) {
  let { isLastPage, items } = useInfiniteHits<TResult>();

  const hasResults = Boolean(items.length);
  if (!hasResults) {
    return null;
  }

  if (config.isWalled) {
    items = items.slice(0, 1);
  }

  const Wrapper = config.ui.card.wrapper;

  return (
    <ul className={classNames(styles.bettingInsightsResults, { [styles.lastPage]: isLastPage })}>
      {items.map((item, resultIndex) => {
        const content = config.ui.card.table.getContent({ result: item });

        return (
          <li aria-labelledby="#bet-name" data-testid="result-card" key={`${item.objectID}`}>
            <Wrapper
              config={config}
              content={content}
              resourcesUrl={resourcesUrl}
              result={item}
              resultIndex={resultIndex}
            >
              {content.map((contentItem, tableIndex) => {
                return (
                  <ResultTable
                    bookmakers={bookmakers}
                    content={contentItem}
                    key={`result-table-${tableIndex}`}
                    label={item.subeventName}
                    resourcesUrl={resourcesUrl}
                    resultIndex={resultIndex}
                    styles={config.ui.card.styles}
                    table={config.ui.card.table}
                    tableIndex={tableIndex}
                  />
                );
              })}
            </Wrapper>
          </li>
        );
      })}
    </ul>
  );
}
